import React from 'react';
import OnboardingScreenEnhanced from '../../src/screens/auth/OnboardingScreenEnhanced';
import { useAuth } from '../../src/context/AuthContext';

export default function OnboardingRoute() {
  const { refreshAuth } = useAuth();
  return <OnboardingScreenEnhanced onContinue={refreshAuth} />;
}
